import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { warrantyFaqItems } from "@/config/warranty-faq";
import { SectionHeader } from "./SectionHeader";
import { useI18n } from "@/i18n";
import { getMarketingCopy } from "@/i18n/marketing-copy";

export function Faq() {
  const { t, locale } = useI18n();
  const localizedWarrantyFaqs = getMarketingCopy(locale)?.about.guarantee.faqs;
  const items = [...t.faq.items, ...(localizedWarrantyFaqs ?? warrantyFaqItems)];

  return (
    <section id="faq" className="section-y">
      <div className="container-page grid gap-12 lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)]">
        <SectionHeader eyebrow={t.faq.eyebrow} title={t.faq.title} />

        <Accordion type="single" collapsible className="w-full">
          {items.map((item, i) => (
            <AccordionItem key={`${item.q}-${i}`} value={`faq-${i}`}>
              <AccordionTrigger className="text-left text-[0.98rem] font-medium">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
